<div class="card">
	<div class="card-header">{{ 'ENTER_CAP_CODE_TITLE' | translate }}</div>
	<div class="card-body">
		<p>{{ 'ENTER_CAP_CODE_MESSAGE' | translate }}</p>
		<div class="row">
			<div class="col">
				<form #form="ngForm">
					<div class="row">
						<div class="col mb-3">
							<div class="form-floating">
								<input type="text" class="form-control" id="capCodeInput" name="inputCapCode" [(ngModel)]="inputCapCode" maxlength="4" required>
								<label for="capCodeInput">{{ 'CAP_CODE' | translate }}</label>
							</div>
						</div>
					</div>
				</form>
			</div>
			<div class="col"><button type="button" class="btn btn-primary" (click)="onSearch()">Search</button></div>
		</div>
		<div class="row" *ngIf="personList">
			<div class="col mb-3">
				<div class="form-floating">
					<select class="form-select" id="personInput" name="person" [(ngModel)]="person"  required>
						<option *ngFor="let person of personList" [ngValue]="person">{{person.firstName}} {{person.surname}}</option>
					</select>
					<label for="personInput">{{ 'MILITANT' | translate }}</label>
				</div>
			</div>
		</div>
		<div class="row" *ngIf="person">
			<div class="col">{{ 'PREREGISTERED_CONFIRM' | translate }}</div>
		</div>
		<div class="row" *ngIf="person">
			<div class="col mb-3">
				<div class="form-floating">
					<table class="table table-striped table-bordered">
						<tbody>
							<tr>
								<th>{{ 'NAME' | translate }}</th>
								<th>{{ 'SURNAME' | translate }}</th>
							</tr>
							<tr>
								<td>{{ person.firstName }}</td>
								<td>{{ person.surname }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<p><i class="bi bi-exclamation-triangle-fill text-warning me-2"></i> {{ 'SERVICE_SELECTION_CONFIRM_WARNING' | translate }}</p>
		<p>{{ 'SERVICE_SELECTION_CONFIRM_INSTRUCTION' | translate }}</p>
	</div>
	<div class="card-footer">
		<div class="dialog-actions">
			<!-- <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button> -->
			<button type="button" class="btn btn-primary" (click)="onConfirm()" [disabled]="person === undefined">Confirm</button>
		</div>
	</div>
</div>